import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduleFlowId = Brand<number, 'ScheduleFlowId'>;
export const ScheduleFlowId = createBranded<ScheduleFlowId>();
